import { AMOUNTS } from 'constants/amounts';

export const convertCustomerAmountValue = (value: unknown) => {
  const amount = String(value).replace(/\D/g, '');
  if (!Number.isNaN(parseInt(amount, 10))) {
    return String(Math.max(Math.min(parseInt(amount, 10), AMOUNTS.amountMax), AMOUNTS.amountMin));
  }
  return String(AMOUNTS.defaultFormValue);
};
